export const mediaItems = [
  {
    id: 1,
    title: '暴走黑料·六月最新爆料合集',
    thumbnail: 'https://readdy.ai/api/search-image?query=dark%20dramatic%20entertainment%20news%20studio%20background%20with%20red%20accents%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20modern%20media%20set%20with%20abstract%20geometric%20elements%2C%20professional%20broadcast%20aesthetic%2C%20deep%20shadows%20and%20warm%20highlights&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '18:42',
    views: '128.6万',
    tag: '暴走黑料',
  },
  {
    id: 2,
    title: '黑料社·独家内幕深度揭秘特辑',
    thumbnail: 'https://readdy.ai/api/search-image?query=exclusive%20investigative%20news%20studio%20scene%20with%20dramatic%20red%20and%20black%20lighting%2C%20elegant%20dark%20backdrop%2C%20professional%20broadcast%20environment%2C%20mysterious%20and%20compelling%20visual%20style%2C%20high%20contrast%20editorial%20photography&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '22:15',
    views: '96.3万',
    tag: '黑料社',
  },
  {
    id: 3,
    title: '本周热门黑料大盘点·必看精选',
    thumbnail: 'https://readdy.ai/api/search-image?query=trending%20entertainment%20gossip%20news%20compilation%20visual%20with%20dynamic%20warm%20lighting%2C%20modern%20digital%20screen%20display%2C%20stylized%20abstract%20background%20with%20subtle%20patterns%2C%20professional%20broadcast%20aesthetic%2C%20engaging%20and%20dramatic%20composition&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '15:30',
    views: '203.7万',
    tag: '热门精选',
  },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=stylized%20anonymous%20user%20avatar%20profile%20picture%20with%20warm%20orange%20gradient%20background%2C%20minimalist%20design%2C%20modern%20flat%20illustration%20style%2C%20simple%20geometric%20shape&width=80&height=80&seq=avatar-01&orientation=squarish',
    nickname: '吃瓜不嫌事大',
    time: '2小时前',
    content: '暴走黑料系列真的太敢爆了，每期必追！小编整理得很用心，终于不用到处找了。',
    likes: 1283,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=stylized%20anonymous%20user%20avatar%20profile%20picture%20with%20soft%20amber%20gradient%20background%2C%20minimalist%20design%2C%20modern%20flat%20illustration%20style%2C%20simple%20circle%20shape&width=80&height=80&seq=avatar-02&orientation=squarish',
    nickname: '深夜吃瓜人',
    time: '5小时前',
    content: '黑料社的内容质量一直很稳定，已经推荐给身边所有朋友了，大家都说好！',
    likes: 967,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=stylized%20anonymous%20user%20avatar%20profile%20picture%20with%20coral%20gradient%20background%2C%20minimalist%20design%2C%20modern%20flat%20illustration%20style%2C%20simple%20hexagon%20shape&width=80&height=80&seq=avatar-03&orientation=squarish',
    nickname: '料事如神',
    time: '8小时前',
    content: '每天上班摸鱼必刷黑料在线，更新速度全网最快，比别家早半天以上。',
    likes: 2156,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=stylized%20anonymous%20user%20avatar%20profile%20picture%20with%20rose%20gradient%20background%2C%20minimalist%20design%2C%20modern%20flat%20illustration%20style%2C%20simple%20diamond%20shape&width=80&height=80&seq=avatar-04&orientation=squarish',
    nickname: '八卦小能手',
    time: '12小时前',
    content: '系列化整理太方便了，暴走黑料从第一期追到现在，黑料社也每期不落。',
    likes: 845,
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=stylized%20anonymous%20user%20avatar%20profile%20picture%20with%20warm%20red%20gradient%20background%2C%20minimalist%20design%2C%20modern%20flat%20illustration%20style%2C%20simple%20triangle%20shape&width=80&height=80&seq=avatar-05&orientation=squarish',
    nickname: '前排小板凳',
    time: '1天前',
    content: '这个站简直吃瓜群众的快乐源泉！黑料社在线观看体验很流畅，收藏了。',
    likes: 1532,
  },
];

export const updateItems = [
  {
    id: 1,
    time: '2026.07.30 14:30',
    title: '暴走黑料七月重磅特辑上线，多角度深度起底最新热点事件',
    tag: '最新',
  },
  {
    id: 2,
    time: '2026.07.30 10:15',
    title: '黑料社独家专访：圈内人士首次公开回应连日争议话题',
    tag: '独家',
  },
  {
    id: 3,
    time: '2026.07.29 21:00',
    title: '本周黑料热度榜更新，三大热门系列观看量突破500万',
    tag: '热门',
  },
  {
    id: 4,
    time: '2026.07.29 16:45',
    title: '暴走黑料特别篇：跨越三年的系列追踪迎来大结局',
    tag: '重磅',
  },
  {
    id: 5,
    time: '2026.07.28 19:30',
    title: '平台新增黑料社经典合集入口，一键回顾历史精彩内容',
    tag: '更新',
  },
  {
    id: 6,
    time: '2026.07.28 11:00',
    title: '七月吃瓜指数报告发布：黑料在线月活用户突破新高',
    tag: '数据',
  },
  {
    id: 7,
    time: '2026.07.27 20:15',
    title: '黑料社海外特辑系列上线，带你了解不一样的爆料视角',
    tag: '新系列',
  },
  {
    id: 8,
    time: '2026.07.27 08:30',
    title: '暴走黑料与黑料社联合专题推出，双系列对比解读',
    tag: '联动',
  },
];

export const aboutContent = {
  title: '关于黑料在线',
  description: '黑料在线是国内领先的系列化黑料整理与观看平台，专注收集暴走黑料、黑料社等特色黑料系列内容。我们以独特视角梳理热门事件脉络，为用户带来一站式的系列化吃瓜体验。平台自上线以来，凭借快速更新、内容全面、系列化整理三大优势，已成为吃瓜爱好者每日必刷的热门站点。无论是最新爆料的暴走黑料在线观看，还是深度揭秘的黑料社在线观看，黑料在线都致力于让你看得过瘾、吃得尽兴。',
  stats: [
    { label: '系列专题', value: '200+' },
    { label: '日活用户', value: '50万+' },
    { label: '月更新量', value: '300+' },
  ],
};

export const cardItems = [
  {
    id: 1,
    title: '暴走黑料·七月风暴',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20visual%20with%20bold%20red%20accents%20on%20dark%20background%2C%20stylized%20abstract%20design%20representing%20hot%20topics%2C%20cinematic%20composition%20with%20dynamic%20energy%2C%20editorial%20aesthetic%20with%20warm%20highlights&width=600&height=400&seq=card-01&orientation=landscape',
    desc: '本月最劲爆的暴走黑料合集，多方视角完整还原事件全貌。',
    tag: '暴走黑料',
    views: '368万',
  },
  {
    id: 2,
    title: '黑料社·深度起底系列',
    image: 'https://readdy.ai/api/search-image?query=investigative%20journalism%20style%20visual%20with%20mysterious%20atmosphere%2C%20dark%20red%20and%20charcoal%20tones%2C%20dramatic%20lighting%20on%20abstract%20subject%2C%20professional%20editorial%20photography%20with%20deep%20shadows&width=600&height=400&seq=card-02&orientation=landscape',
    desc: '黑料社独家深度起底，层层剥开事件背后的真相与细节。',
    tag: '黑料社',
    views: '285万',
  },
  {
    id: 3,
    title: '六月黑料热度总榜',
    image: 'https://readdy.ai/api/search-image?query=ranking%20chart%20visualization%20with%20warm%20amber%20and%20coral%20gradients%2C%20abstract%20data%20display%20concept%2C%20modern%20infographic%20style%20with%20dramatic%20background%2C%20professional%20editorial%20design&width=600&height=400&seq=card-03&orientation=landscape',
    desc: '六月全网最热黑料大盘点，一篇文章看尽整月精彩。',
    tag: '月度榜单',
    views: '512万',
  },
  {
    id: 4,
    title: '黑料系列追更指南',
    image: 'https://readdy.ai/api/search-image?query=organized%20content%20library%20visual%20with%20warm%20lighting%2C%20elegant%20dark%20background%20with%20subtle%20red%20accents%2C%20modern%20editorial%20layout%20concept%2C%20professional%20magazine%20style%20photography&width=600&height=400&seq=card-04&orientation=landscape',
    desc: '新来的吃瓜群众必看，暴走黑料和黑料社全系列追更路线。',
    tag: '追更指南',
    views: '198万',
  },
  {
    id: 5,
    title: '圈内人爆料合集',
    image: 'https://readdy.ai/api/search-image?query=anonymous%20source%20leak%20concept%20visual%20with%20dark%20mysterious%20atmosphere%2C%20warm%20spotlight%20on%20abstract%20object%2C%20dramatic%20editorial%20photography%20with%20deep%20contrast%20and%20intrigue&width=600&height=400&seq=card-05&orientation=landscape',
    desc: '多位圈内人士匿名爆料，第一手内幕信息独家整理发布。',
    tag: '独家爆料',
    views: '436万',
  },
  {
    id: 6,
    title: '黑料考古·经典回顾',
    image: 'https://readdy.ai/api/search-image?query=vintage%20archive%20concept%20with%20warm%20sepia%20and%20deep%20red%20tones%2C%20retro%20editorial%20aesthetic%20mixed%20with%20modern%20design%2C%20nostalgic%20yet%20dramatic%20visual%20style%2C%20professional%20magazine%20photography&width=600&height=400&seq=card-06&orientation=landscape',
    desc: '那些年轰动一时的经典黑料，重新整理打包供你回顾品味。',
    tag: '经典回顾',
    views: '156万',
  },
  {
    id: 7,
    title: '跨界黑料联动专题',
    image: 'https://readdy.ai/api/search-image?query=cross%20industry%20connection%20concept%20visual%20with%20interconnected%20abstract%20shapes%2C%20warm%20red%20and%20amber%20gradients%2C%20dynamic%20editorial%20design%20with%20dramatic%20lighting%2C%20professional%20magazine%20style&width=600&height=400&seq=card-07&orientation=landscape',
    desc: '当暴走黑料遇上黑料社，跨系列事件关联性深度分析。',
    tag: '联动专题',
    views: '278万',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '全天候实时追踪，热点事件发生后的最短时间内完成整理上线，让你永远快人一步。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '系列化整理',
    desc: '暴走黑料、黑料社等热门系列按时间线和逻辑关系完整归档，追更体验流畅不掉队。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每条黑料经过多源交叉验证后才发布，确保内容真实可靠，拒绝虚假信息误导。',
  },
  {
    id: 4,
    icon: 'ri-eye-line',
    title: '独家视角',
    desc: '黑料社团队深入挖掘事件背后的故事，提供独一无二的深度解读与独家内幕。',
  },
  {
    id: 5,
    icon: 'ri-group-line',
    title: '吃瓜社区',
    desc: '活跃的读者评论区与你一起讨论最新热点，分享观点、交流看法，吃瓜更有趣。',
  },
];

export const topicItems = [
  { id: 1, name: '暴走黑料', heat: '999+', color: 'primary' },
  { id: 2, name: '黑料社', heat: '888+', color: 'accent' },
  { id: 3, name: '圈内爆料', heat: '756', color: 'secondary' },
  { id: 4, name: '明星八卦', heat: '689', color: 'primary' },
  { id: 5, name: '综艺黑幕', heat: '567', color: 'accent' },
  { id: 6, name: '网红翻车', heat: '532', color: 'secondary' },
  { id: 7, name: '行业起底', heat: '498', color: 'primary' },
  { id: 8, name: '独家专访', heat: '445', color: 'accent' },
  { id: 9, name: '年度盘点', heat: '412', color: 'secondary' },
  { id: 10, name: '跨界联动', heat: '389', color: 'primary' },
];

export const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '暴走黑料·七月风暴特辑',
    heat: '🔥🔥🔥🔥🔥',
    tag: '暴走黑料',
    desc: '本季最火爆的系列，单期观看量突破800万',
  },
  {
    id: 2,
    rank: 2,
    title: '黑料社·圈内人匿名大爆料',
    heat: '🔥🔥🔥🔥🔥',
    tag: '黑料社',
    desc: '多位业内人士首次集体发声，信息量巨大',
  },
  {
    id: 3,
    rank: 3,
    title: '跨界黑料·娱乐圈与资本圈深度关联',
    heat: '🔥🔥🔥🔥',
    tag: '跨界专题',
    desc: '揭开商业与娱乐背后的隐秘关系网络',
  },
  {
    id: 4,
    rank: 4,
    title: '综艺黑幕大起底·选秀背后的故事',
    heat: '🔥🔥🔥🔥',
    tag: '综艺专题',
    desc: '从选手到制作方，全方位还原选秀真实面貌',
  },
  {
    id: 5,
    rank: 5,
    title: '网红翻车年度合集·那些年翻过的车',
    heat: '🔥🔥🔥',
    tag: '网红专题',
    desc: '精心整理年度最具代表性的网红翻车事件',
  },
];

export const contactContent = {
  title: '投稿与合作',
  description: '如果你有独家爆料线索或希望与我们进行内容合作，欢迎通过以下方式联系。我们重视每一条线索，严格保护爆料人隐私。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@heiliao.online' },
    { icon: 'ri-wechat-line', label: '微信联系', value: 'heiliao_tips' },
    { icon: 'ri-shield-user-line', label: '隐私承诺', value: '严格保护爆料人身份信息' },
  ],
};

export const appContent = {
  title: '随时随地 畅快吃瓜',
  description: '黑料在线移动端已覆盖iOS与Android两大平台，支持离线缓存、推送通知、夜间模式等实用功能，让你无论何时何地都能第一时间获取最新黑料。扫描二维码或在应用商店搜索"黑料在线"即可下载。',
  features: ['离线缓存', '推送通知', '夜间模式', '高清流畅'],
};

export const indexItems = [
  {
    id: 1,
    title: '暴走黑料全集',
    count: '48期',
    desc: '最受欢迎的暴走黑料系列，从第一期到最新一期完整收录。',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20dramatic%20news%20topics%20visual%20with%20bold%20red%20highlights%2C%20dark%20elegant%20background%2C%20organized%20grid%20concept%2C%20editorial%20magazine%20style%20photography&width=400&height=280&seq=index-01&orientation=landscape',
  },
  {
    id: 2,
    title: '黑料社全系列',
    count: '36期',
    desc: '黑料社深度起底系列，独家视角带你了解事件背后的真相。',
    image: 'https://readdy.ai/api/search-image?query=investigative%20series%20collection%20visual%20with%20mysterious%20dark%20amber%20lighting%2C%20elegant%20editorial%20design%2C%20sophisticated%20magazine%20aesthetic%20with%20dramatic%20composition&width=400&height=280&seq=index-02&orientation=landscape',
  },
  {
    id: 3,
    title: '圈内人爆料档案',
    count: '25期',
    desc: '匿名圈内人士独家爆料合集，第一手内幕信息整理发布。',
    image: 'https://readdy.ai/api/search-image?query=anonymous%20leaks%20archive%20concept%20with%20dark%20mysterious%20atmosphere%2C%20redacted%20document%20visual%20style%2C%20professional%20editorial%20photography%20with%20dramatic%20shadows&width=400&height=280&seq=index-03&orientation=landscape',
  },
  {
    id: 4,
    title: '月度热度排行榜',
    count: '12期',
    desc: '每月热门黑料走势与排名，一图掌握当月吃瓜风向。',
    image: 'https://readdy.ai/api/search-image?query=monthly%20ranking%20chart%20visual%20with%20warm%20gradient%20colors%2C%20abstract%20data%20display%20design%2C%20modern%20infographic%20aesthetic%2C%20professional%20editorial%20style&width=400&height=280&seq=index-04&orientation=landscape',
  },
  {
    id: 5,
    title: '综艺黑幕特辑',
    count: '18期',
    desc: '聚焦综艺节目背后的争议事件与行业内幕深度解析。',
    image: 'https://readdy.ai/api/search-image?query=television%20show%20behind%20scenes%20concept%20with%20dramatic%20lighting%2C%20dark%20stage%20background%20with%20warm%20spotlight%2C%20editorial%20photography%20with%20theatrical%20mood&width=400&height=280&seq=index-05&orientation=landscape',
  },
  {
    id: 6,
    title: '网红翻车实录',
    count: '22期',
    desc: '从直播翻车到人设崩塌，网红圈的那些经典翻车时刻。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20social%20media%20scandal%20concept%20with%20bold%20red%20and%20dark%20contrast%2C%20abstract%20digital%20aesthetic%2C%20modern%20editorial%20design%20with%20intense%20energy&width=400&height=280&seq=index-06&orientation=landscape',
  },
  {
    id: 7,
    title: '明星八卦周刊',
    count: '56期',
    desc: '每周精选娱乐圈最新动态与八卦消息，吃瓜群众必追栏目。',
    image: 'https://readdy.ai/api/search-image?query=celebrity%20gossip%20magazine%20cover%20concept%20with%20glamorous%20dark%20red%20aesthetic%2C%20paparazzi%20style%20visual%2C%20editorial%20photography%20with%20dramatic%20and%20elegant%20composition&width=400&height=280&seq=index-07&orientation=landscape',
  },
  {
    id: 8,
    title: '行业起底报告',
    count: '15期',
    desc: '深入行业内部，揭秘不为人知的商业规则与利益链条。',
    image: 'https://readdy.ai/api/search-image?query=corporate%20investigation%20report%20visual%20with%20dark%20professional%20aesthetic%2C%20dramatic%20office%20lighting%2C%20abstract%20business%20concept%2C%20editorial%20magazine%20style%20photography&width=400&height=280&seq=index-08&orientation=landscape',
  },
  {
    id: 9,
    title: '黑料考古系列',
    count: '30期',
    desc: '回顾历史上那些轰动一时的经典黑料，跨越时间再看真相。',
    image: 'https://readdy.ai/api/search-image?query=vintage%20archive%20newspaper%20concept%20with%20warm%20sepia%20and%20dark%20red%20tones%2C%20retro%20editorial%20aesthetic%2C%20nostalgic%20magazine%20style%20photography%20with%20dramatic%20lighting&width=400&height=280&seq=index-09&orientation=landscape',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '暴走黑料·七月风暴',
    subtitle: '本月最劲爆合集',
    image: 'https://readdy.ai/api/search-image?query=breaking%20news%20spotlight%20visual%20with%20bold%20red%20and%20black%20dramatic%20composition%2C%20cinematic%20lighting%20on%20abstract%20scene%2C%20powerful%20editorial%20design%2C%20magazine%20cover%20quality%20with%20intense%20energy&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '爆款',
  },
  {
    id: 2,
    title: '黑料社·圈内人发声',
    subtitle: '独家内幕大揭秘',
    image: 'https://readdy.ai/api/search-image?query=exclusive%20interview%20spotlight%20with%20dramatic%20amber%20and%20dark%20lighting%2C%20mysterious%20silhouette%20on%20elegant%20backdrop%2C%20cinematic%20editorial%20style%20with%20intrigue%20and%20depth&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '独家',
  },
  {
    id: 3,
    title: '跨界联动·深度解析',
    subtitle: '当娱乐遇上资本',
    image: 'https://readdy.ai/api/search-image?query=cross%20industry%20connection%20concept%20with%20interconnected%20abstract%20elements%2C%20warm%20red%20and%20gold%20gradients%2C%20dramatic%20editorial%20design%2C%20sophisticated%20magazine%20cover%20aesthetic&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '深度',
  },
  {
    id: 4,
    title: '综艺黑幕大起底',
    subtitle: '选秀背后的真实故事',
    image: 'https://readdy.ai/api/search-image?query=stage%20behind%20the%20scenes%20dramatic%20visual%20with%20dark%20theatrical%20lighting%2C%20red%20velvet%20curtain%20aesthetic%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20with%20cinematic%20mood&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '揭秘',
  },
  {
    id: 5,
    title: '六月热度总榜',
    subtitle: '全网最热黑料一览',
    image: 'https://readdy.ai/api/search-image?query=trending%20topics%20ranking%20visual%20with%20dynamic%20warm%20gradients%2C%20abstract%20data%20visualization%2C%20modern%20infographic%20design%20with%20dramatic%20dark%20background%2C%20editorial%20quality&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '热门',
  },
  {
    id: 6,
    title: '黑料考古经典',
    subtitle: '这些年我们追过的爆料',
    image: 'https://readdy.ai/api/search-image?query=retro%20archive%20collection%20visual%20with%20warm%20sepia%20and%20dark%20red%20tones%2C%20vintage%20newspaper%20aesthetic%2C%20nostalgic%20editorial%20design%20with%20dramatic%20shadows%20and%20texture&width=800&height=500&seq=carousel-06&orientation=landscape',
    tag: '经典',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '黑料在线是一个什么样的平台？',
    answer: '黑料在线是国内领先的系列化黑料整理与观看平台，专注收集暴走黑料、黑料社等特色黑料系列内容。我们以独特视角梳理热门事件脉络，通过系列化方式为用户提供完整、系统的吃瓜体验，涵盖娱乐八卦、行业揭秘、网红事件等多种类型。',
  },
  {
    id: 2,
    question: '暴走黑料和黑料社有什么区别？',
    answer: '暴走黑料系列以快节奏、高密度的热点事件梳理为主，适合快速了解最新爆点；黑料社系列则偏向深度起底与独家揭秘，每期围绕一个核心话题进行全方位挖掘。两个系列各有侧重，建议搭配观看，体验更佳。',
  },
  {
    id: 3,
    question: '如何第一时间获取最新黑料更新？',
    answer: '你可以通过黑料在线移动端App开启推送通知功能，第一时间接收热门黑料更新提醒。同时，平台首页的快讯板块会实时更新最新动态，建议将黑料在线加入浏览器收藏夹，每日访问不错过任何精彩内容。',
  },
  {
    id: 4,
    question: '如何向平台投稿或提供爆料线索？',
    answer: '我们非常欢迎读者提供独家爆料线索。你可以通过平台的联系我们页面中的投稿邮箱或微信号与我们取得联系。我们郑重承诺严格保护每一位爆料人的隐私与身份信息，所有线索均经过加密处理。',
  },
];